var TorsoView = require('backbone-torso/modules/View');
var wizardPerspectiveTemplate = require('./../wizard/wizardPerspectiveTemplate.hbs');
var PortalPerspectiveLayoutBehavior = require('./../PortalPerspectiveLayoutBehavior');
var AsideBehavior = require('./../aside/AsideBehavior');
var WizardAccessBehavior = require('./../wizard/WizardAccessBehavior');
var WizardPerspectiveBehavior = require('./../wizard/WizardPerspectiveBehavior');
var launcherAppInterface = require('./../launcherApplicationInterface');
var AppointmentFormWidget = require('./AppointmentFormWidget');

/**
 * Perspective to display the Appointment Form page
 *
 * @class AppointmentFormPerspective
 * @param options {Object} Options to configure this perspective.
 *   @param [options.patientVecnaId] {String} the vecna id of the current patient
 *   @param [options.appointmentExternalId] {String} the external id of the current appointment
 */
module.exports = TorsoView.extend({
  className: 'app app--appointment-form',
  template: wizardPerspectiveTemplate,
  moduleNamespace: 'appointmentFormPerspective',

  behaviors: {
    portalPerspectiveLayoutBehavior: {
      behavior: PortalPerspectiveLayoutBehavior
    },
    asideBehavior: {
      behavior: AsideBehavior,
      asideHeaderMessageKey: 'aside.information.header',
      asideContentMessageKey: launcherAppInterface.isAtHospital() ? 'appointment.form.aside.ereg' : 'appointment.form.aside'
    },
    wizardAccessBehavior: WizardAccessBehavior,
    wizardPerspectiveBehavior: {
      behavior: WizardPerspectiveBehavior,
      pageName: WizardPerspectiveBehavior.PAGE_NAMES.FORMS
    }
  },

  /**
   * @method initialize
   * @override
   * @param options {Object} Options to configure this perspective.
   *   @param [options.patientVecnaId] {String} the vecna id of the current patient
   *   @param [options.appointmentExternalId] {String} the external id of the current appointment
   *   @param [options.regDate] {String} the date of the current appointments
   *   @param [options.formName] {String} the name of the form to display.
   */
  initialize: function(options) {
    // These are set for the wizard behaviors.
    this._patientVecnaId = options.patientVecnaId;
    this._appointmentExternalId = options.appointmentExternalId;
    this._regDate = options.regDate;

    this._appointmentFormWidget = new AppointmentFormWidget({
      patientVecnaId: options.patientVecnaId,
      appointmentExternalId: options.appointmentExternalId,
      formName: options.formName
    });

    this.getBehavior('wizardPerspectiveBehavior').setContentView(this._appointmentFormWidget);
  }
});
